export default __webpack_public_path__ + "static/media/Paul_Sethy.fdee73b0.jpg";